import React from 'react';

type Props = { children: React.ReactNode };
type State = { hasError: boolean; message?: string };

export class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: any): State {
    return { hasError: true, message: error?.message || String(error) };
  }

  componentDidCatch(error: any, info: any) {
    // Keep logging minimal in production, but record useful info
    console.error('Runtime error caught by ErrorBoundary:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center p-6 bg-gray-50">
          <div className="max-w-md w-full space-y-3 text-center">
            <h1 className="text-lg font-semibold text-red-700">エラーが発生しました</h1>
            <p className="text-sm text-gray-700">ページの読み込み中に問題が発生しました。再読み込みするか、管理者にお問い合わせください。</p>
            {this.state.message && (
              <pre className="text-xs text-red-800 bg-red-50 border border-red-200 rounded p-2 overflow-auto">{this.state.message}</pre>
            )}
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;

